module.exports = __webpack_public_path__ + "img/SC4-income.cb5fca20.svg";